// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".police-container[data-v-b6c70876]{background:#fff}.police-frame[data-v-b6c70876]{background:rgba(0,0,0,.4);border:1px solid #fff;border-radius:7px;padding:19px}.loader[data-v-b6c70876]{position:absolute;top:50%;transform:translate(-50%,50%);left:50%;width:370px;height:150px;max-width:100%;box-shadow:8px 6px 7px 0 rgba(0,0,0,.30196078431372547)}", ""]);
// Exports
module.exports = exports;
